import { useSelector } from "react-redux";
import { PlaySvg } from "../../assets/svgs";
import ButtonComponent from "../button";
import InputComponent from "../input";
import { NotificationDot, ReportCatalogSidebarbody, ReportCatalogSidebarContainer, ReportCatalogSidebarHead, ReportCatalogSidebarItems, ReportCatalogSidebarSearch } from "./report-catalog-sidebar.style";
import { Fragment, useEffect, useState } from "react";

const ReportCatalogSidebar = ({ data, selected, handleSidebarClick, handleToggleJobsModal }) => {
    const { user } = useSelector((state) => state.loginUserReducer);
    const { jobs } = useSelector((state) => state.ReportCatalogReducer);

    const sidebarModules = data || [];

    const [states, setStates] = useState({
        isJobUpdate: false
    });

    const [searchTerm, setSearchTerm] = useState("");  // New state for search input
    const [filteredModules, setFilteredModules] = useState(sidebarModules);  // New state to store filtered modules

    const handleJobClick = () => {
        if (handleToggleJobsModal) {
            handleToggleJobsModal();
            setStates((old) => ({ ...old, isJobUpdate: false }));
        }
    };

    useEffect(() => {
        setStates((prev) => ({
            ...prev,
            isJobUpdate: jobs && jobs?.length > 0
        }));
    }, [jobs]);

    // Handle search input and filter the modules
    const handleSearch = (e) => {
        const searchValue = e.target.value;
        setSearchTerm(searchValue);

        // Filter the modules based on the search input
        const filtered = sidebarModules.filter((module) =>
            module.label.toLowerCase().includes(searchValue.toLowerCase())
        );
        setFilteredModules(filtered);
    };

    return (
        <ReportCatalogSidebarContainer>
            {/* head */}
            <ReportCatalogSidebarHead>
                <h2>Report Catalog</h2>
                <ReportCatalogSidebarSearch>
                    {/* search */}
                    <InputComponent
                        placeholder="Search"
                        type="text"
                        value={searchTerm}  // Bind search input value
                        onChange={handleSearch}  // Update search term
                    />
                    <div style={{ position: 'relative' }}>
                        <ButtonComponent label="Jobs" size="small" rounded onClick={handleJobClick} />
                        {
                            states?.isJobUpdate &&
                            <NotificationDot />
                        }
                    </div>
                </ReportCatalogSidebarSearch>
            </ReportCatalogSidebarHead>
            {/* body */}
            <ReportCatalogSidebarbody className="custom-scrollbar">
                {
                    filteredModules && filteredModules?.length > 0 ? filteredModules?.map((module, index) => (
                        <Fragment key={index}>
                            {
                                user?.permissions && user?.permissions.length > 0 && user?.permissions?.some(permission => permission?.pageUrl === module?.permissionUrl) &&
                                <ReportCatalogSidebarItems onClick={() => handleSidebarClick(module)} className={selected?.value === module?.value ? 'active' : ''}>
                                    {module.label}
                                    <PlaySvg />
                                </ReportCatalogSidebarItems>
                            }
                        </Fragment>
                    )) : (
                        <div style={{ textAlign: 'center' }}>
                            <p>No module found.</p>
                        </div>
                    )
                }
            </ReportCatalogSidebarbody>
        </ReportCatalogSidebarContainer>
    );
}

export default ReportCatalogSidebar;